export default __webpack_public_path__ + "assets/yodlee-7540b43a863af4b086943403b8d26967.png";